<template>
  <div class="claim-start-card">
    <!-- header -->
    <div class="claim-start-card__header mb-3">
      <span class="claim-start-card__badge">
        <span class="claim-start-card__badge-icon" />
      </span>
      <span class="claim-start-card__title">Comenzar Reclamación</span>
    </div>

    <!-- radios -->
    <div class="custom-control custom-radio mb-2">
      <input
        :id="`${name}-auto`"
        v-model="localValue"
        class="custom-control-input"
        :name="name"
        type="radio"
        :value="true"
      />
      <label class="custom-control-label" :for="`${name}-auto`">
        <strong>Automática:</strong>
        Se generará batch de todos los servicios elegibles a reclamar.
      </label>
    </div>

    <div class="custom-control custom-radio mb-3">
      <input
        :id="`${name}-manual`"
        v-model="localValue"
        class="custom-control-input"
        :name="name"
        type="radio"
        :value="false"
        @input="$emit('is-automatic', false)"
      />
      <label class="custom-control-label" :for="`${name}-manual`">
        <strong>Manual:</strong>
        Deberá seleccionar manualmente los servicios que desea enviar a
        reclamación.
      </label>
    </div>

    <!-- alerta -->
    <div
      class="alert alert-warning rounded border border-danger font-weight-bold claim-start-card__alert"
      role="alert"
    >
      <i class="fas fa-bell-exclamation mr-2" />
      Se creará un registro de Batch por cada Lugar de Servicio elegible.
    </div>

    <!-- acciones -->
    <div class="d-flex justify-content-end mt-3">
      <action-button
        i="fas fa-times-circle"
        text="Cancelar"
        variant="outline-danger mr-3 pl-3 pr-4"
        @click="$emit('cancel')"
      />
      <action-button
        i="fas fa-chevron-circle-right"
        :text="localValue ? 'Concluir' : 'Continuar'"
        variant="success pl-3 pr-4"
        @click="$emit('confirm', localValue)"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ClaimStartCard',
  props: {
    value: {
      type: Boolean,
      default: true,
    },
    name: {
      type: String,
      default: 'claimType',
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
};
</script>

<style scoped>
.claim-start-card {
  background: #f7f7f7;
  border: 3px solid transparent;
  border-left-color: #ff7058;
  border-radius: 5px;
  padding: 16px;
}

.claim-start-card__header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.claim-start-card__badge {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #ff7058;
  color: #fff;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.12);
}

.claim-start-card__title {
  display: flex;
  align-items: center;
  height: 30px;
  font-weight: 700;
  font-size: 18px;
  color: #2f3a3c;
}

::v-deep .custom-control-label {
  line-height: 1.4;
  color: #2f3a3c;
}

.claim-start-card__alert {
  margin-bottom: 0;
  background-color: #fdefdd !important;
}
.claim-start-card__badge-icon {
  width: 18px;
  height: 18px;

  background-color: #fff;

  -webkit-mask: url('../../../../assets/icons/file-circle-exclamation.svg')
    no-repeat center / contain;
  mask: url('../../../../assets/icons/file-circle-exclamation.svg') no-repeat
    center / contain;
}
</style>
